import type {Interpolation} from '@emotion/react';

import {css} from '@emotion/react';

export const styles: Record<string, Interpolation> = {
  tooltip: css`
    vertical-align: middle;
    margin-bottom: 2px;
  `,
};
